import pinia from "@/plugins/pinia";
import { useRequestDataStore } from "@/store/request-data";
import { BaseMenuEntry } from "./base-menu-entry";

export class DosagesMenuEntry extends BaseMenuEntry
{
    protected requestDataStore = useRequestDataStore(pinia);

    public getPicto() : string
    {
        return require("@/assets/pictos/menu-entries/03-dosages.svg");
    }

    public isEnabled() : boolean
    {
        return this.requestDataStore.isDrugModelSelected;
    }

    public isValid() : boolean
    {
        return this.requestDataStore.hasDosages;
    }

    public isValidated() : boolean
    {
        return this.isValid();
    }

    public toggleValidation() : void
    {
        // Validation is not controlled by the user in this entry
        return;
    }
}
